<template>

  <TableSpinner :loading="loading">
    <slot></slot>
    <slot name="table" :records="visibleRecords"></slot>
    <div class="solo-pagination-container">
      <slot name="before-pagination"></slot>
      <el-pagination
          background
          class="wide-page-size"
          layout="sizes, prev, pager, next"
          :total="records.length"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :hide-on-single-page="true"
          :pager-count="3"
          :current-page="currentPage"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
      >
      </el-pagination>
      <slot name="after-pagination"></slot>
    </div>
  </TableSpinner>

</template>

<script>

export default {
  name: "SimpleTechnoTable",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    records: {
      type: Array,
      default: []
    }
  },
  mounted() {
  },
  methods: {
    handlePageSizeChange(newSize) {
      this.pageSize = newSize
    },
    handleCurrentPageChange(newPage) {
      this.currentPage = newPage
    },
    getVisibleRows(){
      return this.visibleRecords
    }
  },
  computed: {
    visibleRecords() {
      return this.records.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    }
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1
    }
  }
}

</script>